import { render, staticRenderFns } from "./EditorSettingsPreviewData.vue?vue&type=template&id=e6e50b10&scoped=true"
import script from "./EditorSettingsPreviewData.vue?vue&type=script&lang=ts"
export * from "./EditorSettingsPreviewData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e50b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6e50b10')) {
      api.createRecord('e6e50b10', component.options)
    } else {
      api.reload('e6e50b10', component.options)
    }
    module.hot.accept("./EditorSettingsPreviewData.vue?vue&type=template&id=e6e50b10&scoped=true", function () {
      api.rerender('e6e50b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/EditorSettingsPreviewData.vue"
export default component.exports